import React from 'react';

// Size-group ranges for the "Size groups" node: { label, min, max }. A value
// matches when it is >= min and < max, so ranges never overlap; an empty max
// means "and above".
export default function GroupsControl({ label, value = [], onChange }) {
  const update = (index, patch) =>
    onChange(value.map((group, i) => (i === index ? { ...group, ...patch } : group)));
  const remove = (index) => onChange(value.filter((_, i) => i !== index));
  const add = () => onChange([...value, { label: '', min: null, max: null }]);

  return (
    <div className="form-field">
      <span className="form-label">{label}</span>
      {value.map((group, index) => (
        <div className="bin-row" key={index}>
          <input
            className="bin-label"
            type="text"
            placeholder="small"
            value={group.label || ''}
            onChange={(e) => update(index, { label: e.target.value })}
          />
          <input
            className="bin-min"
            type="number"
            placeholder="min"
            value={group.min == null ? '' : group.min}
            onChange={(e) => update(index, { min: numberOrNull(e.target.value) })}
          />
          <input
            className="bin-max"
            type="number"
            placeholder="max"
            value={group.max == null ? '' : group.max}
            onChange={(e) => update(index, { max: numberOrNull(e.target.value) })}
          />
          <button
            type="button"
            className="bin-remove"
            onClick={() => remove(index)}
            title="Remove range"
          >
            ×
          </button>
        </div>
      ))}
      <button type="button" className="btn btn-secondary" onClick={add}>
        + Range
      </button>
    </div>
  );
}

function numberOrNull(raw) {
  return raw === '' ? null : Number(raw);
}
